/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Cart",
  size: 20
}

const SvgCart = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle cx={7.3} cy={17.3} r={1.4} />
    <circle cx={13.3} cy={17.3} r={1.4} />
    <path fill="none" d="M0 2l3.2 2 2.1 8.5H16l2-6H8" />
  </Svg>
)

SvgCart.defaultProps = defaultProps
export default SvgCart
